import {
  ChangeDetectorRef,
  Directive,
  TemplateRef,
  ViewContainerRef,
  computed,
  effect,
  inject,
  input,
  untracked,
} from '@angular/core';
import { Config } from '../../models/config.interface';
import { CONFIG } from '../../tokens/config.token';

@Directive({
  selector: '[appFeatureEnabled]',
  standalone: true,
})
export class FeatureEnabledDirective {
  private readonly config = inject(CONFIG);
  private readonly changeDetectorRef = inject(ChangeDetectorRef);
  private readonly templateRef = inject<TemplateRef<unknown>>(TemplateRef);
  private readonly viewContainerRef = inject(ViewContainerRef);

  readonly appFeatureEnabled = input.required<keyof Config['features']>();

  readonly appFeatureEnabledAnd = input<boolean, unknown>(true, {
    transform: (value) => Boolean(value),
  });

  readonly appFeatureEnabledElse = input<TemplateRef<unknown> | null>(null);

  private readonly featureEnabled = computed(() => {
    const feature = this.appFeatureEnabled();
    return Boolean(this.config.features[feature]);
  });

  private readonly shouldShow = computed(
    () => this.featureEnabled() && this.appFeatureEnabledAnd(),
  );

  constructor() {
    effect(() => {
      const show = this.shouldShow();
      const elseTemplate = this.appFeatureEnabledElse();

      untracked(() => {
        this.viewContainerRef.clear();
        if (show) {
          this.viewContainerRef.createEmbeddedView(this.templateRef);
        } else if (elseTemplate) {
          this.viewContainerRef.createEmbeddedView(elseTemplate);
        }
        this.changeDetectorRef.markForCheck();
      });
    });
  }
}
